// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"197":"50d2b127","279":"c2d5457c","361":"492d2756","539":"e7117698","628":"937b1f3f","783":"33044a9c","943":"63eee225"}[chunkId] + ".chunk.js";
};